import CanEditRadioBoxGroup from './component';

export default CanEditRadioBoxGroup;
